import React from 'react';

const GetPreparedWall: React.FC = () => {
  return (
    <div>
      <div className="flex justify-center p-10">
        <iframe
          src="https://padlet.com/eufmdFAST/get-prepared-ekdyee7j5u8df2fb"
          width="1860"
          height="898"
          frameBorder="0"
          title="Get Prepared Wall"
        ></iframe>
      </div>
    </div>
  );
};

export default GetPreparedWall;
